import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  change(event) {
    const locale = event.target.value
    const url = new URL(window.location.href)
    url.searchParams.set("locale", locale)
    window.location.href = url.toString()
  }
}
